export const getToken = () => localStorage.getItem("auth_token");
